// What the matrix chart draws from, ported from Matrix.ChartView#renderReactChart.
//
// The block hands over what the question is and how it is being read; everything the chart needs
// about the report -- the mode and zoom it is set to, the palette, the trait it is broken down by --
// is read here rather than travelling through the shell.

import { getColorTheme, getFeature, getFeatures, getModelValue, getTrait } from '@aytm/app/stats/lib/stat-page'
import { isRType as calcIsRType, isTraitType as calcIsTraitType } from '@aytm/app/stats/page/components/lib/utils'
import PageGlobals from '@aytm/app/stats/lib/page/page-globals'

export const calcChartProps = ({
  id,
  questionKey,
  type,
  subType,
  format,
  answer,
  batches,
  viewMode,
  labelsMode,
  topsMode,
  chartMode,
  zoomLevel,
  sortOrder,
  degree,
  maxAnswerPosition,
  handlers = {}
} = {}) => ({
  questionId: id,
  questionKey,
  qType: type,
  subType,
  viewMode,
  labelsMode,
  topsMode,
  chartMode,
  globalChartMode: getModelValue('chartMode'),
  zoomLevel,
  globalZoomLevel: getModelValue('zoomLevel'),
  answer,
  batches,
  rType: calcIsRType({ type, subType }) ? getModelValue('rType') : 'cases',
  degree,
  maxAnswerPosition,
  format,
  colorTheme: getColorTheme(),
  chartLegendMode: getModelValue('chartLegendMode'),
  // the score views draw an interval band and a significance hatch, and both are read at the level
  // the report is set to, out of the levels the page loaded with
  confidenceLevel: getModelValue('confidenceLevel'),
  significanceLevel: getModelValue('significanceLevel'),
  confidenceLevels: PageGlobals.CONFIDENCE_LEVELS,
  sortOrder,
  isTraitType: calcIsTraitType({ format, type }),
  trait: getTrait(),
  // the chart's download menu offers TURF only while the account has it on
  features: getFeatures(),
  viewOptionsDisabled: Boolean(getFeature('view_options')?.disabled),
  onChartModeChange: handlers.onChartModeChange,
  onZoomChange: handlers.onZoomChange,
  onChartReady: handlers.onChartReady
})
